export abstract class ModelBase {
	public id: string;
}
